var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1523px",
    height: "1161px",
    viewBox: "0 0 1523 1161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Webpixels.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maintenance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.3,888.8 C464.8,851.7 444.5,781.1 463.6,729.8 C477.4,692.6 508.7,673.8 545.1,652.3 C661.2,583.7 727.3,620.4 761.7,570 C797.7,517.2 733.3,465.2 769.7,374 C795.4,309.8 837.5,310.2 843.3,260.4 C852,185.7 760.9,153.7 771.7,93.7 C782.6,33.4 890.1,-19.7 956.6,8.2 C1016.8,33.5 991.5,103.6 1056,161.3 C1147.5,243.1 1266.3,163 1355.3,243.4 C1404.3,287.7 1422.9,361.3 1417.8,417.7 C1405.6,553.3 1258.4,571.2 1234.5,724.7 C1223.1,797.9 1251,829.9 1219,882.8 C1175.7,954.4 1081,968.1 1069.6,969.6 C962.5,983.6 940.7,909.7 809.6,886.8 C653,859.5 576.4,949 507.3,888.8 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.2,485.3 L1514.6,357.8 L1465.1,360.8 C1456.1,330 1442,301.5 1423.9,276.1 L1456.8,239 L1361.3,154.3 L1328.4,191.4 C1301,176.4 1271,165.9 1239.4,160.6 L1236.4,111.1 L1108.9,118.7 L1111.9,168.2 C1081.1,177.2 1052.6,191.3 1027.2,209.4 L990.1,176.5 L905.4,272 L942.5,304.9 C927.5,332.3 917,362.3 911.7,393.9 L862.2,396.9 L869.8,524.4 L919.3,521.4 C928.3,552.2 942.4,580.7 960.5,606.1 L927.6,643.2 L1023.1,727.9 L1056,690.8 C1083.4,705.8 1113.4,716.3 1145,721.6 L1148,771.1 L1275.5,763.5 L1272.5,714 C1303.3,705 1331.8,690.9 1357.2,672.8 L1394.3,705.7 L1479,610.2 L1441.9,577.3 C1456.9,549.9 1467.4,519.9 1472.7,488.3 L1522.2,485.3 Z M1201,589.8 C1118.9,594.7 1048.4,532.1 1043.4,450 C1038.4,367.9 1101.1,297.4 1183.2,292.4 C1265.3,287.5 1335.8,350.1 1340.8,432.2 C1345.8,514.3 1283.1,584.8 1201,589.8 Z",
    id: "Shape",
    fill: "#f97316",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.5,421.8 C820.5,407.7 832.2,392.2 841.4,375.6 L896.2,390.2 L922.6,291.1 L867.8,276.5 C868.3,238.2 858.4,199.7 838,165.8 L878.1,125.7 L805.5,53.2 L765.4,93.3 C731.4,73 692.9,63.2 654.6,63.8 L639.8,9 L540.7,35.7 L555.4,90.4 C538.9,99.7 523.3,111.3 509.3,125.4 C495.3,139.5 483.6,155 474.4,171.6 L419.6,157 L393.3,256 L448.1,270.6 C447.6,308.9 457.5,347.4 477.9,381.3 L437.8,421.4 L510.4,493.9 L550.5,453.8 C584.5,474.1 623,483.9 661.3,483.3 L676.1,538.1 L775.2,511.4 L760.5,456.7 C776.9,447.5 792.5,435.8 806.5,421.8 Z M586.3,345.3 C546.6,305.7 546.6,241.5 586.1,201.8 C625.7,162.1 689.9,162.1 729.6,201.6 C769.3,241.2 769.3,305.4 729.8,345.1 C690.3,384.8 626,384.9 586.3,345.3 Z",
    id: "Shape",
    fill: "#CED5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.5,
    y1: 1010.4,
    x2: 940.6,
    y2: 1010.4,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#fb923c",
    fillRule: "nonzero",
    points: "475.8 539.4 655.5 661.1 639.9 688.2 447.6 571.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "426.1 805.1 407.5 928.6 359.4 1110.2 393.1 1112.6 461 936.9 499.1 807.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero",
    points: "447.6 824.6 499.5 947.8 523.9 1140.7 558.7 1121.4 553.1 925.5 515.8 786.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero",
    points: "417.6 781.1 399.7 927.1 369.3 1057.1 416.9 1066.5 473.8 933.5 505.6 779.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero",
    points: "417 786.1 487.5 950.1 513.6 1086.6 558.7 1078.9 562.8 921.9 522.2 768.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,1086.6 C365.1,1086.6 360.2,1087 359.1,1092.1 C358,1097.2 352.7,1119.2 352.7,1119.2 C352.7,1119.2 349.9,1125.6 365.5,1130 C381,1134.5 447.2,1153.1 447.2,1153.1 C447.2,1153.1 454.6,1146.8 448.6,1138.8 C442.7,1130.8 398.5,1096.4 398.5,1096.4 C398.5,1096.4 391.5,1099.7 379.7,1096.3 C367.9,1092.9 365.1,1086.6 365.1,1086.6 Z",
    id: "Path",
    fill: "#f97316",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.4,1116.3 C520.4,1116.3 515.5,1118.2 515.9,1123.7 C516.3,1129.2 517.6,1153.1 517.6,1153.1 C517.6,1153.1 516.7,1160.4 533.8,1160.3 C550.9,1160.1 623.7,1159.2 623.7,1159.2 C623.7,1159.2 629.3,1150.6 620.9,1144.2 C612.5,1137.8 557.3,1116.2 557.3,1116.2 C557.3,1116.2 551.2,1121.6 538.2,1121.8 C525.2,1122 520.4,1116.3 520.4,1116.3 Z",
    id: "Path",
    fill: "#f97316",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#ED85C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "417 786.1 487.5 950.1 513.6 1086.6 558.7 1078.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.3,566 C1213.9,607.6 1171.3,631 1118.4,634.5 C1082.7,636.9 1049.7,627.4 1018.6,609.9 C995.9,597.1 971.5,592.9 946,600.8 C940.2,602.6 934.2,604.1 928.4,605.9 C795.9,648.4 663.5,691.1 530.9,733.5 C491.8,746 452.4,757.7 413.1,769.5 C403.6,772.3 393.7,775 383.6,772.8 C339,763.2 311.4,718.4 325.7,675.8 C332,656.8 342.6,641.6 362.5,634.5 C372.8,630.8 382.8,626.3 393.2,622.9 C477.7,594.9 562.4,567.1 646.9,539.1 C730.2,511.5 813.5,483.9 896.7,455.9 C913.2,450.3 926.1,439 935,424.2 C944.7,408.3 953,391.5 962.1,375.1 C966,368.1 969.6,360.7 974.7,354.6 C1003.9,319 1041.8,298.5 1087.2,292.1 C1128.2,286.4 1165.9,296.4 1200.7,317.9 C1210.3,323.8 1218.9,331.6 1227.4,339.3 C1232.3,343.7 1231.5,346.2 1225.4,348.5 C1214.3,352.7 1203.1,356.8 1191.8,360.7 C1168.7,368.8 1145.7,377 1122.5,384.8 C1100.3,392.3 1088.4,421.8 1093.1,439.9 C1096.4,452.5 1099.6,465.2 1103.8,477.5 C1106.9,486.8 1110.6,496 1115.5,504.5 C1125.3,521.5 1147.3,530.9 1166.5,526.9 C1174.2,525.3 1181.8,523.1 1189.4,520.9 C1214.2,513.4 1239,505.6 1263.8,498.2 C1267.2,497.2 1270.9,497.5 1274.5,497.2 C1274.4,501.2 1275.3,505.6 1274.1,509.3 C1270.7,519.3 1266.4,529.1 1262.6,538.8 C1257,548.1 1252.7,557.9 1246.3,566 Z M380.8,728.4 C397,736.8 417.5,730.4 425.7,714.5 C434.5,697.4 429,676.3 412.8,669 C393.5,660.3 375.5,667.9 367.2,683.6 C359.1,699.6 365.4,720.4 380.8,728.4 Z",
    id: "Shape",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#f97316",
    fillRule: "nonzero",
    points: "1208.4 364.4 1133.8 388.6 1117.5 465.4 1175.8 517.8 1250.4 493.6 1266.7 416.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.4,516.4 C437.4,516.4 414.8,542.1 413,573.1 C411.2,604.1 409.6,791 409.6,791 C409.6,791 514.3,790.7 528.9,776.2 C528.9,776.2 516,619.9 505,581.6 C494.1,543.4 462.9,522.5 462.9,522.5 L437.4,516.4 Z",
    id: "Path",
    fill: "#fb923c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,706.3 C586,706.3 598.1,717.6 604.8,719.1 C611.5,720.6 617.5,720.6 623.6,718.1 C629.4,715.7 637.9,714.1 636.1,708.3 C633.8,700.9 613.2,692.9 613.2,692.9 C613.2,692.9 631.8,699.1 633.2,695.7 C634.6,692.2 620.2,687.3 611.4,684.2 C602.6,681.1 598,681.8 598,681.8 L586,706.3 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1,493.1 L437.4,516.4 C437.4,516.4 446.3,524.1 462.9,522.5 L458.9,496.5 C458.9,496.4 452.8,486.4 442.1,493.1 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.2,418.6 C486.2,418.6 496.4,490.4 479.1,503.6 C461.8,516.8 435.1,484.7 435.1,484.7 C435.1,484.7 399.7,453.5 414.1,422.1 C428.6,390.8 483.9,395.6 486.2,418.6 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#fb923c",
    fillRule: "nonzero",
    points: "457.2 547.6 513.7 630.2 601.1 677.5 586 708.4 494.9 664.5 429.9 585.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.6,492.5 C442.6,492.5 389.1,481.1 398.2,429 C407.3,376.9 487.2,386.1 486.4,420.5 C486.4,420.5 470.3,424.8 454.7,425.6 C439.2,426.4 445.9,461.7 445.9,461.7 C445.9,461.7 444.4,463.6 443.3,460.5 C441.5,455.1 438.6,443.8 429.9,448.4 C421.1,453 430,470 440.6,472.7 C440.7,472.6 445.3,484.2 442.6,492.5 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#283444",
    fillRule: "nonzero",
    cx: 393.3,
    cy: 420.4,
    r: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.7,
    y1: 630.2,
    x2: 457.2,
    y2: 547.6,
    id: "Path",
    stroke: "#f97316",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#f97316",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "429.9 585.3 494.9 664.5 586 708.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.1,694.5 C653.1,694.5 651.4,681.3 666.8,675.7 C682.2,670.1 691.7,682.6 691.7,682.6 C691.7,682.6 690.5,690.9 674.4,694.5 C658.1,698 658,699.2 653.1,694.5 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.4,516.4 C437.4,516.4 445.3,523.8 462.9,522.5 C462.9,522.5 477.2,532 489.9,550.2 C502.6,568.4 504.8,579.9 506.1,585.8",
    id: "Path",
    stroke: "#f97316",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1208.4,
    y1: 364.4,
    x2: 1175.8,
    y2: 517.8,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero",
    points: "689 219.8 626.9 219.8 595.9 273.5 626.9 327.2 689 327.2 720 273.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2,885.3 C42.2,885.3 -7.3,848.8 1.4,810.5 C15,750.8 57.3,749.2 17.4,664.6 C-14,598 49.7,609.6 47,558 C45.3,526.5 31,504 40.5,466.9 C50.3,429 68.2,426.8 77.3,397.3 C81,385.2 73.2,359.3 78.6,338.8 C95.2,275.9 185.2,332 157.4,456.4 C150.5,487.5 197.1,496.8 199.5,542.3 C202.2,594 172,612.2 187.6,641.1 C208.4,679.6 243.4,673.3 211.7,739.6 C186.4,792.6 269.8,854.9 190.2,891.8 C110.6,928.7 67.7,900.7 42.2,885.3 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 526.2,
    x2: 118,
    y2: 987.4,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 811.9,
    x2: 74.5,
    y2: 737.3,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 710.6,
    x2: 162.5,
    y2: 670,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 619.1,
    x2: 89.8,
    y2: 573.8,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 787.5,
    x2: 155,
    y2: 756.8,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 683.3,
    x2: 93.8,
    y2: 649.9,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,958.9 C47.8,986.9 48.4,1020.5 64.2,1048 L64.2,1048 C72.6,1062.6 88.1,1071.5 104.9,1071.5 L131.1,1071.5 C147.9,1071.5 163.4,1062.5 171.8,1048 L171.8,1048 C187.7,1020.5 188.3,986.9 173.6,958.9 L62.4,958.9 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3b4be9436b6618e5b4f6025404b63ff6.svg";
export { ForwardRef as ReactComponent };